export default {
  data() {
    return {
      rules: {
        email: [
          v => !!v || this.$t("E-mail is required"),
          v => /.+@.+\..+/.test(v) || this.$t("E-mail must be valid"),
        ],
        required: [v => !!v || this.$t("This field is required")],
        password: [
          v => !!v || this.$t("Password is required"),
          v => v === this.form.password || this.$t("Passwords do not match"),
        ],
      },
    };
  },
};
